var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0011 27.2403C14.5329 27.2403 12.2115 26.2812 10.4661 24.5358C8.7208 22.7905 7.76172 20.4691 7.76172 18.0008C7.76172 14.9393 9.27378 12.0793 11.8112 10.357C12.0012 10.2274 12.2201 10.1583 12.4505 10.1583C12.8278 10.1583 13.1821 10.3455 13.3952 10.6566C13.7466 11.1779 13.6112 11.8864 13.0928 12.2406C11.1804 13.5395 10.0399 15.6939 10.0399 18.0008C10.0399 21.84 13.1619 24.9621 17.0011 24.9621C20.8374 24.9621 23.9595 21.84 23.9595 18.0008C23.9595 15.6939 22.819 13.5395 20.9066 12.2406C20.3881 11.8864 20.2528 11.1779 20.607 10.6566C20.8173 10.3455 21.1715 10.1583 21.5517 10.1583C21.7792 10.1583 22.001 10.2274 22.1882 10.357C24.7256 12.0793 26.2405 14.9393 26.2405 18.0008C26.2405 20.4691 25.2786 22.7905 23.5332 24.5358C21.7879 26.2812 19.4694 27.2403 17.0011 27.2403Z",
    fill: "url(#paint0_linear_3872_1253)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0009 18.4905C16.3701 18.4905 15.8604 17.9778 15.8604 17.3499V7.90029C15.8604 7.27243 16.3701 6.75977 17.0009 6.75977C17.6287 6.75977 18.1385 7.27243 18.1385 7.90029V17.3499C18.1385 17.9778 17.6287 18.4905 17.0009 18.4905Z",
    fill: "url(#paint1_linear_3872_1253)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1253",
    x1: 17.0011,
    y1: 10.1583,
    x2: 17.0011,
    y2: 27.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3872_1253",
    x1: 16.9994,
    y1: 6.75977,
    x2: 16.9994,
    y2: 18.4905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.b9f2a2927d9de38f1d670cfc94f75459.svg";
export { ForwardRef as ReactComponent };